module.exports = __webpack_public_path__ + "assets/studyset-inactive.ae16a5c1.svg";